import React from "react";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Skeleton,
} from "@mui/material";

const DocumentListSkeleton = () => {
  return (
    <Box p={1.5}>
      {[1, 2, 3, 4, 5].map((item) => (
        <Box key={item} sx={{ px: 1, py: 1.2 }}>
          <Skeleton variant="text" width="70%" height={24} />
          <Skeleton variant="text" width="45%" height={18} />
        </Box>
      ))}
    </Box>
  );
};

const DocumentSidebar = ({
  documents = [],
  loading,
  selectedDocIndex,
  onSelectDocument,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        width: 320,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
      }}
    >
      <Box sx={{ px: 2, py: 1.5 }}>
        <Typography fontWeight={600}>Document List</Typography>
      </Box>

      <Divider />

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        {loading ? (
          <DocumentListSkeleton />
        ) : documents?.length > 0 ? (
          <List disablePadding>
            {documents.map((doc, idx) => (
              <ListItem key={doc?.id || idx} disablePadding>
                <ListItemButton
                  selected={selectedDocIndex === idx}
                  onClick={() => onSelectDocument(idx, doc)}
                  sx={{
                    alignItems: "flex-start",
                    py: 1.5,
                    px: 2,
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        fontWeight={selectedDocIndex === idx ? 700 : 600}
                        fontSize={14}
                        color="text.primary"
                      >
                        {doc?.filetitle || doc?.filename || "Untitled"}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          mt: 0.4,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          fontSize: 12,
                        }}
                      >
                        {doc?.filedescription ||
                          doc?.filename ||
                          doc?.notes ||
                          "No description"}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        ) : (
          <Box sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              No documents available.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default DocumentSidebar;
